
import { defineComponent } from "vue";

import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCardTitle,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonCardSubtitle,
} from "@ionic/vue";
import { personOutline, personSharp } from "ionicons/icons";
import { store, useStore } from "../store";

const getPartName = () => {
  return store.state.gameState
    ? store.state.gameState.cast.get(store.state.username)
    : "";
};

export default defineComponent({
  name: "Part",
  setup() {
    const store = useStore();
    return { personOutline, personSharp, store };
  },
  computed: {
    part() {
      const part = getPartName();
      return part ? part : "Du hast noch keine Rolle";
    },
    profile() {
      const partName = getPartName();
      if (partName && store.state.game) {
        const matches = store.state.game.players.filter(
          (player) => {
              
              return player.name == partName;
              }
        );
        console.log(JSON.stringify( matches[0]));
        if (matches.length > 0) return matches[0];
      }
      return null;
    },
  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonCard,
    IonCardHeader,
    IonCardContent,
    IonCardSubtitle,
    IonCardTitle,
  },
});
